import { type FortuneApis } from '@dni-types/api-definitions/fortune'
import { createMutationHelper } from '@utils/swr'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type PaymentOrderHash } from '../types/dataModel/eCommercePayments'

const { useMutation } = createMutationHelper<FortuneApis['get']['paymentTransaction'], PaymentTransactionResponse, { orderHash: PaymentOrderHash }>({
  client: 'fortuneGuest',
  key: '/payment_transactions',
  fetcher: (_, { arg, client }) => {
    if (!arg.orderHash) {
      return Promise.reject(new Error('Order hash is required'))
    }
    return client.get(`/payment_transactions/${arg.orderHash}`)
  },
})

export const useApiGetGuestPaymentTransactionMutation = useMutation
